module.exports = __webpack_public_path__ + "84d7d8ce5e152dab1045ca41054b1673.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/img-layout/SpacecraftDesignEngineering600x500-min.jpg
 ** module id = 506
 ** module chunks = 1
 **/